import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import type { DeliveryInput } from "../../domain/types";

type DeliveryFormProps = {
  value: DeliveryInput;
  onChange: (value: DeliveryInput) => void;
  errors?: Record<string, string>;
  branchId: string | null;
  partners: Array<{ id: string; name: string; code?: string | null }>;
  isLoadingPartners?: boolean;
};

export function DeliveryForm({
  value,
  onChange,
  errors,
  branchId,
  partners,
  isLoadingPartners = false,
}: DeliveryFormProps) {
  const handleChange = (field: keyof DeliveryInput, newValue: string) => {
    onChange({
      ...value,
      [field]: newValue.trim() || undefined,
    });
  };

  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-sm">ຂໍ້ມູນການຈັດສົ່ງ</h3>

      <div className="space-y-4">
        {/* Delivery Partner Selection - Required */}
        <div>
          <Label htmlFor="partnerId" className="mb-2 block text-sm">
            ຄູ່ຄ້າຈັດສົ່ງ <span className="text-destructive">*</span>
          </Label>
          <Select
            value={value.partnerId || ""}
            onValueChange={(val) => handleChange("partnerId", val)}
            disabled={isLoadingPartners || !branchId}
          >
            <SelectTrigger
              id="partnerId"
              className={errors?.partnerId ? "border-destructive" : ""}
            >
              <SelectValue placeholder="ເລືອກຄູ່ຄ້າຈັດສົ່ງ" />
            </SelectTrigger>
            <SelectContent>
              {partners.length === 0 ? (
                <SelectItem value="no-partners" disabled>
                  {isLoadingPartners ? "ກຳລັງໂຫຼດ..." : "ບໍ່ມີຄູ່ຄ້າຈັດສົ່ງ"}
                </SelectItem>
              ) : (
                partners.map((partner) => (
                  <SelectItem key={partner.id} value={partner.id}>
                    {partner.name}
                    {partner.code && ` (${partner.code})`}
                  </SelectItem>
                ))
              )}
            </SelectContent>
          </Select>
          {errors?.partnerId && (
            <p className="mt-1 text-destructive text-xs">{errors.partnerId}</p>
          )}
        </div>

        {/* Instructions */}
        <div>
          <Label htmlFor="instructions" className="mb-2 block text-sm">
            ຄຳແນະນຳສຳລັບຄົນຂັບ
          </Label>
          <textarea
            id="instructions"
            value={value.instructions || ""}
            onChange={(e) => handleChange("instructions", e.target.value)}
            placeholder="ປ້ອນຄຳແນະນຳ (ທາງເລືອກ)"
            className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          />
        </div>
      </div>
    </div>
  );
}
